import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import './Auth.css';

export const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const success = await login(email, password);
    if (!success) {
      setError('Nieprawidłowy adres email lub hasło.');
    }
    setLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-split-layout">
        <div className="auth-branding">
          <div className="brand-section">
            <img src="/logo-radonek.png" alt="Radonek Logo" className="auth-logo" />
            <div className="brand-info">
              <h1>Radonek</h1>
              <p className="brand-subtitle">Asystent pacjenta onkologicznego</p>
            </div>
          </div>
          <div className="about-section">
            <h3>Jak działa aplikacja Radonek?</h3>
            <div className="key-features">
              <div className="feature-highlight">
                <div className="feature-icon">💡</div>
                <div className="feature-content">
                  <h4>Dwie odpowiedzi na kazde pytanie</h4>
                  <p>Dane logowania otrzymasz od swojego lekarza. Zadaj pytanie naszemu asystenowi. Asystent wykorzysta wiedzę na temat twojej choroby i dolegliwości, którą otrzymał od Twojego lekarza. Dzięki temu otrzymasz odpowiedzi dotyczące dokładnie Twojego przypadku.</p><p>Na zadane pytania otrzymasz dwie odpowiedzi: jedną wykorzystującą wiedzę, którą przygotowaliśmy specjalnie dla naszych pacjentów (RAG) i drugą od strandardowego modelu sztucznej inteligencji (ChatGPT 4o). Wybierz, która będzie bardziej pomocna. Odpowiedzi omówisz ze swoim lekarzem na wizycie.</p>
                </div>
              </div>
              <div className="feature-highlight">
                <div className="feature-icon">🎤</div>
                <div className="feature-content">
                  <h4>Wygodne sposoby komunikacji</h4>
                  <p>Zadawaj pytania pisząc lub mówiąc. Odpowiedzi mozesz odsłuchać.</p>
                </div>
              </div>
              <div className="feature-highlight">
                <div className="feature-icon">�</div>
                <div className="feature-content">
                  <h4>Pełna prywatność i bezpieczeństwo</h4>
                  <p>Radonek jest prospektywnym obserwacyjnym badaniem naukowym, ale Twoje dane są bezpieczne, a w celach analizy bedą anonimizowane. Twoje rozmowy są poufne i dostępne tylko dla Ciebie i Twojego lekarza. </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="auth-form-wrapper">
          <div className="auth-card">
            <div className="auth-header">
              <div className="form-title">
                <h2>Logowanie do systemu</h2>
                <p className="auth-form-subtitle">Twoje centrum wsparcia w leczeniu</p>
              </div>
            </div>
            
            <form onSubmit={handleSubmit} className="auth-form">
              <div className="form-group">
                <label htmlFor="email">Adres email</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={loading}
                  placeholder="nazwa@email.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Hasło</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={loading}
                  placeholder="Wprowadź swoje hasło"
                />
              </div>

              {error && <div className="error-message">{error}</div>}

              <button type="submit" disabled={loading} className="auth-button">
                {loading ? 'Logowanie...' : 'Zaloguj się'}
              </button>

              <div className="auth-links">
                <Link to="/password-reset" className="auth-link">
                  Nie pamiętasz hasła?
                </Link>
                <Link to="/activate" className="auth-link">
                  Aktywacja konta (8-cyfrowy kod)
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
